<template>
  <div v-if="isPc != 3 && isShow">
    <div class="footer">
      <div class="main text-white">
        <div class="to-top flex-col items-center" @click="backTop">
          <img src="@/assets/images/logo.png" style="margin-bottom: 54px; width: 100px;height: 70px;">
        </div>
        <div class="article-type flex-row">
          <div class="article-type-item" v-for="item in navMenu.slice(0, 5)" :key="item.title">
            <router-link :to="{ path: item.to }">
              <h3>{{ item.title }}</h3>
            </router-link>
          </div>
        </div>
        <div class="article-type flex-row">
          <div class="article-type-item" v-for="item in navMenu.slice(5, 10)" :key="item.title">
            <router-link :to="{ path: item.to }">
              <h3>{{ item.title }}</h3>
            </router-link>
          </div>
        </div>
        <div class="privacy justify-center items-center">
          <!-- <div class="privacy-left items-center">
            <h3 @click="openPop('隱私權政策', 'relatedByCulture')">
              隱私權政策
            </h3>
            <h3 @click="openPop('會員權益', 'relatedByInterests')">會員權益</h3>
          </div> -->
          <div class="privacy-right items-center">
            <h4>{{ L('台商杂志媒体矩阵：') }}</h4>
            <a href="https://www.facebook.com/TS960/" target="blank" class="items-center justify-center"
              @mouseenter="hoverIcon('facebook')" @mouseleave="hoverIcon('facebook')">
              <svg-icon v-if="!facebookActive" icon-class="facebook" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
              <svg-icon v-else icon-class="facebook-active" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
            </a>
            <!-- <a href="http://weixin.qq.com/r/13WHn6XEG-hkreH89yDF" target="blank" class="items-center justify-center" @mouseenter="hoverIcon('wx')" @mouseleave="hoverIcon('wx')">
              <svg-icon v-if="!wxActive" icon-class="wx" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
              <svg-icon v-else icon-class="wx-active" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
            </a> -->
            <el-popover class="wx-popover" style="font-size: 0; cursor: pointer;" placement="bottom" width="200"
              trigger="hover">
              <div class="wx-popover-content">
                <img src="@/assets/images/qcode/wx.jpg" style="width: 100%;height: 100%;">
              </div>
              <svg-icon slot="reference" color="#2C2C2E" hover-color="#34C759" icon-class="wx"></svg-icon>

            </el-popover>

            <a href="https://www.youtube.com/channel/UCHiVD1zjXzBs0XvhTu5b3pA" target="blank"
              class="items-center justify-center" @mouseenter="hoverIcon('youtube')" @mouseleave="hoverIcon('youtube')">
              <svg-icon v-if="!youtubeActive" icon-class="youtube" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
              <svg-icon v-else icon-class="youtube-active" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
            </a>
            <a href="https://weibo.com/u/1890106622" target="blank" class="items-center justify-center"
              @mouseenter="hoverIcon('wb')" @mouseleave="hoverIcon('wb')">
              <svg-icon v-if="!wbActive" icon-class="wb" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
              <svg-icon v-else icon-class="wb-active" color="#2C2C2E" hover-color="#2C2C2E"></svg-icon>
            </a>
            <a href="https://www.toutiao.com/c/user/token/MS4wLjABAAAA2nDgbCE4iGqok4SR_nWRK2d5Dro0O-ceo9w3DdnjSkE/"
              target="blank" class="items-center justify-center" @mouseenter="hoverIcon('tt')"
              @mouseleave="hoverIcon('tt')">
              <svg-icon v-if="!ttActive" icon-class="tt" color="#2C2C2E"></svg-icon>
              <svg-icon v-else icon-class="tt-active" color="#2C2C2E"></svg-icon>
            </a>
            <a href="https://www.douyin.com/user/MS4wLjABAAAAjOsLv8o28bYbKOPCcncREobBQ6wvEjANdOgNOeszQDA" target="blank"
              class="items-center justify-center">
              <img src="@/assets/images/dy.png" style="width: 22px;height: 22px;margin-left: 20px;">
            </a>
          </div>
        </div>
        <div class="bottom justify-between items-center">
          <div class="bottom-left items-center">
            <span>Copyright © Golden Bridge Corp. All rights reserved.</span>
            <a href="https://beian.miit.gov.cn" target="_blank" class="icp-link">粤ICP备13059371号</a>
          </div>
          <div class="bottom-right">
            技术支持：台商匯信息科技有限公司
          </div>
        </div>
      </div>
    </div>
    <div class="fix_btn">
      <!-- <el-popover placement="left" width="120" trigger="hover" popper-class="wx_popper">
        <div class="little_hand">會員中心</div>
        <div class="btn_join" slot="reference" @click="toMyCenter">
          <svg-icon class="font22" icon-class="magazine"></svg-icon>
        </div>
      </el-popover>
      <el-popover placement="left" width="120" trigger="hover" popper-class="wx_popper">
        <div class="little_hand">購物清單</div>
        <div class="btn_join shopcar-icon" slot="reference" @click="toMyCart">
          <span v-if="myCartList.total > 0">{{ myCartList.total }}</span>
          <svg-icon class="font22" icon-class="cart-black"></svg-icon>
        </div>
      </el-popover>
      <el-popover v-if="validToken" placement="left" width="120" trigger="hover" popper-class="wx_popper">
        <div class="little_hand">退出登錄</div>
        <div class="btn_join" slot="reference" @click="exit">
          <svg-icon class="font22" icon-class="exit"></svg-icon>
        </div>
      </el-popover>
      <a href="https://www.facebook.com/TS960/" target="blank" class="items-center justify-center">
        <div class="btn_join" slot="reference">
          <svg-icon class="font20" icon-class="facebook-black"></svg-icon>
        </div>
      </a>
      <a href="https://www.youtube.com/channel/UCHiVD1zjXzBs0XvhTu5b3pA" target="blank"
        class="items-center justify-center">
        <div class="btn_join" slot="reference">
          <svg-icon class="font22" icon-class="youtube"></svg-icon>
        </div>
      </a>
      <el-popover placement="left" width="120" trigger="hover" popper-class="wx_popper">
        <div>{{ webInfo.phone }}</div>
        <div class="btn_tel" slot="reference" @click="toTel"><em></em></div>
      </el-popover> -->

      <div class="btn_top" @click="backTop"><svg-icon icon-class="arrow-right" color="#636366"></svg-icon></div>
    </div>
    <el-dialog class="file-pop" :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="file-top" slot="title">
        <h4>{{ dialogTitle }}</h4>
      </div>
      <div class="file-container" v-html="dialogContent"></div>
    </el-dialog>
  </div>
</template>

<script>
import columnTitle from "./column-title.vue";
import { getLinkList } from "@/assets/api/news.js";
import { mapState } from "vuex";
import { getAboutInfo } from "@/assets/api/common.js";

export default {
  components: {
    columnTitle,
  },
  data() {
    return {
      scrollTop: "",
      facebookActive: false,
      wxActive: false,
      youtubeActive: false,
      wbActive: false,
      ttActive: false,
      navMenu: [
        {
          title: "紙質訂閱",
          to: "/magazine",
        },
        {
          title: "智庫專欄",
          to: "/expert",
        },
        {
          title: "故事專訪",
          to: "/story?typeId=14",
        },
        {
          title: "好書推薦",
          to: "/book",
        },
        {
          title: "關於我們",
          to: "/about",
        },
        {
          title: "新聞頭條",
          to: "/article?typeId=13",
        },

        {
          title: "影音視頻",
          to: "/video?typeId=15",
        },
        {
          title: "政策指引",
          to: "/article?typeId=17",
        },
        {
          title: "經貿動態",
          to: "/article?typeId=16",
        },
        {
          title: "生活資訊",
          to: "/article?typeId=18",
        },

      ],
      linkList: [],
      dialogTitle: "",
      dialogContent: "",
      dialogVisible: false,
      currentRoute: "",
      isShow: true
    };
  },
  computed: {
    ...mapState(["isPc", "webInfo", "myCartList", "validToken"]),
  },
  created() {
    this.$store.dispatch("getMyCart");
    // 获取当前路由
    this.currentRoute = this.$route.path;
    console.log(this.currentRoute);
    if (this.currentRoute === "/book-preview") {
      //组件不显示
      this.isShow = false
    }
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    hoverIcon(icon) {
      if (icon === 'facebook') {
        this.facebookActive = !this.facebookActive;
      } else if (icon === 'wx') {
        this.wxActive = !this.wxActive;
      } else if (icon === 'youtube') {
        this.youtubeActive = !this.youtubeActive;
      } else if (icon === 'wb') {
        this.wbActive = !this.wbActive;
      } else if (icon === 'tt') {
        this.ttActive = !this.ttActive;
      }
    },
    init() {
      getLinkList().then((res) => {
        this.linkList = res.data.data.map((item) => {
          item.image = !/^http/.test(item.image)
            ? this.$imgUrl + item.image
            : item.image;
          return item;
        });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    toLink(url) {
      window.open(url, "_blank");
    },
    toMyCart() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.$router.push({
          path: `/magazine-cart`,
        });
      }
    },
    toMyCenter() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.$router.push({
          path: `/member-center`,
        });
      }
    },
    exit() {
      window.sessionStorage.setItem("token", "");
      this.$store.dispatch("checkToken");
      location.reload();
      this.$router.push({
        path: `/`,
      });
    },
    toTel() {
      window.location.href = `tel:${this.webInfo.phone}`;
    },
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 0) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    openPop(title, type) {
      this.dialogTitle = title;
      getAboutInfo(type).then((res) => {
        this.dialogContent = res.data.data.relatedContent;
      });
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.partner {
  .partner-lists {
    .news-item {
      margin-bottom: 70px;
    }

    img {
      width: 128px;
      height: 57px;
      object-fit: contain;
    }
  }
}

.footer {
  padding: 90px 0 20px 0;
  background: #F2F2F7;

  .to-top {
    width: fit-content;
    margin: auto;
    cursor: pointer;

    .svg-icon {
      height: 20.2px;
      width: 10.1px;
      transform: rotate(-90deg);
    }

    h3 {
      font-family: NotoSansCJKTC;
      font-size: 12px;
      color: #fff;
    }
  }

  .article-type {
    display: flex;
    justify-content: center;
  }

  .article-type-item {
    box-sizing: border-box;
    border-right: 1px solid #E5E5EA;
    margin-bottom: 16px;

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      padding: 5px 30px;
    }

    span {
      font-family: NotoSansCJKTC;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 1.4px;
      text-align: left;
      color: #fff;
      padding: 10px 0;
      display: block;
    }
  }

  .article-type-item:last-child {
    border-right: none;
  }

  .privacy {
    padding: 20px 0;
    border-bottom: 1px solid #E5E5EA;

    h3 {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 1.6px;
      text-align: left;
      color: #fff;
      padding: 0 26px;
      cursor: pointer;
    }

    h3:nth-child(2) {
      border-left: 1px solid #fff;
      // border-right: 1px solid #fff;
    }

    .privacy-right {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: center;
      font-style: normal;

      .svg-icon {
        width: 30px;
        height: 30px;
        margin-left: 20px;
      }
    }
  }

  .bottom {
    padding: 20px 0;
    padding-bottom: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #AEAEB2;
    line-height: 19px;
    text-align: right;
    font-style: normal;

    .icp-link {
      margin-left: 15px;
      color: #AEAEB2;
      text-decoration: none;
      transition: color 0.3s ease;

      &:hover {
        color: #2C2C2E;
        text-decoration: underline;
      }
    }
  }
}

.fix_btn {
  position: fixed;
  bottom: 20%;
  right: 27px;
  z-index: 99;

  div {
    // position: relative;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border: 1px solid #E5E5EA;
    // box-shadow: 0px 2px 7px 0px rgba(213, 213, 213, 0.75);
    border-radius: 40px;
    // margin-bottom: 10px;
    background-color: #fff;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  .shopcar-icon {
    position: relative;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -2px;
      right: 2px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #e13133;
      font-size: 12px;
      color: #fff;
    }
  }

  em {
    width: 22px;
    height: 22px;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .btn_tel em {
    background-image: url("../../assets/images/tel.png");
  }

  .btn_top .svg-icon {
    transform: rotate(-90deg);
    width: 20px;
    height: 20px;
  }
}


@media screen and (max-width: 768px) {
  .partner {
    margin: 0 10px;

    .partner-lists {
      .news-item {
        margin-bottom: 32px;
      }

      img {
        width: 100%;
        height: 72px;
        object-fit: contain;
      }
    }
  }

  .footer {
    padding: 20px 0;

    .article-type {
      padding: 15px 10px;
      border-bottom: 1px solid #333;
      display: block;

      .article-type-item {
        flex: 1 0 50%;
        float: left;
        padding: 0 15px;
        margin-bottom: 15px;
        flex: 1;

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 18px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 1.8px;
          text-align: left;
          color: #fff;
          padding: 10px 0;
        }

        span {
          font-family: NotoSansCJKTC;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: 1.4px;
          text-align: left;
          color: #fff;
          padding: 10px 0;
          display: block;
        }
      }

      .article-type-item:nth-child(2n) {
        border-right: none;
      }

      .article-type-item:nth-child(2n + 1) {
        border-right: 1px solid #333;
      }
    }

    .article-type::after {
      content: "";
      clear: both;
      display: block;
    }

    .privacy {
      padding: 15px 0;
      border-bottom: 1px solid #333;
      flex-direction: column;

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        color: #fff;
        padding: 0 26px;
      }

      h3:nth-child(2) {
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
      }

      .privacy-right {
        width: 70%;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .svg-icon {
          width: 30px;
          height: 30px;
          margin-left: 0;
        }
      }
    }

    .bottom {
      padding: 22px;
      padding-bottom: 0;
      flex-direction: column;

      .bottom-left {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;

        .icp-link {
          margin-left: 0;
          margin-top: 8px;
        }

        h3 {
          padding: 2.7px 9px 4.1px 4.8px;
          border-radius: 3px;
          background-image: linear-gradient(116deg, #dc000c -2%, #080101 151%);
          font-family: ToppanBunkyuMidashiMincho;
          font-size: 16px;
          font-weight: 800;
          font-stretch: normal;
          font-style: normal;
          line-height: 17px;
          letter-spacing: 2.64px;
          text-align: left;
          color: #fff;
        }

        .svg-icon {
          width: 62px;
          height: 45px;
          position: relative;
        }
      }

      .bottom-right {
        margin-top: 20px;
      }
    }
  }
}
</style>
<style>
.file-pop .el-dialog {
  width: 86%;
  max-width: 900px;
  margin-top: 0 !important;
  top: 50%;
  transform: translateY(-50%);
}

.file-pop .file-top h4 {
  font-family: NotoSansCJKTC;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #e13133;
}

.file-pop .el-dialog__header {
  padding-top: 30px;
}

.file-pop .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}

.file-pop .el-dialog__body {
  background: #fff;
  padding: 15px 15px 49px 43px;
}

.file-container {
  height: 600px;
  padding-right: 28px;
  overflow-y: scroll;
  font-family: NotoSansCJKTC;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: 1.4px;
  text-align: left;
  color: #000;
}

.file-container::-webkit-scrollbar {
  width: 6px;
}

.file-container::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #c1c2c2;
  /* -webkit-box-shadow:inset 1px 1px 0 rgba(0,0,0,.1); */
}

.file-container::-webkit-scrollbar-track {
  border-radius: 6px;
  background-color: #efefef;
}

@media screen and (max-width: 768px) {
  .file-pop .el-dialog {
    width: 86%;
    height: 95%;
  }

  .file-pop .el-dialog__body {
    height: 91%;
  }

  .file-container {
    height: 100%;
  }
}

.file-container div {
  white-space: break-spaces !important;
}

.wx-popover .el-popover__reference-wrapper {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/common/footer.vue